import { render, staticRenderFns } from "./AllocationsByRegionTable.vue?vue&type=template&id=fb7d9294&scoped=true"
import script from "./AllocationsByRegionTable.vue?vue&type=script&lang=js"
export * from "./AllocationsByRegionTable.vue?vue&type=script&lang=js"
import style0 from "./AllocationsByRegionTable.vue?vue&type=style&index=0&id=fb7d9294&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7d9294",
  null
  
)

export default component.exports